// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryGroup_wrapper__s5PVX","category_group":"CategoryGroup_category_group__LJFLQ","select_box":"CategoryGroup_select_box__dRBwY","arrow":"CategoryGroup_arrow__YqxNU"};